import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBookingDetails } from '../../slices/bookings/thunk';
import { fetchSettings } from '../../slices/settings/thunk';
import { getInvoiceHTML } from './InvoiceTemplate';
import { Spinner } from 'reactstrap';

const InvoiceView = () => {
    const { id } = useParams();
    const dispatch = useDispatch();

    const { settings } = useSelector((state) => ({
        settings: state.Settings?.settings,
    }));

    const [booking, setBooking] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        // Fetch settings if not available
        if (!settings) {
            dispatch(fetchSettings());
        }

        if (id) {
            dispatch(fetchBookingDetails(id)).unwrap()
                .then(res => {
                    setBooking(res.data || res);
                    setLoading(false);
                })
                .catch(err => {
                    console.error('Failed to fetch invoice details:', err);
                    setError(err.message || 'Failed to load invoice');
                    setLoading(false);
                });
        }
    }, [id, dispatch, settings]);

    useEffect(() => {
        if (!loading && booking) {
            // Set the page title
            document.title = `Invoice - ${booking.invoiceToken || booking.id}`;
        }
    }, [loading, booking]);

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <div className="text-center">
                    <Spinner color="primary" />
                    <p className="mt-2 text-muted">Generating Invoice View...</p>
                </div>
            </div>
        );
    }

    if (error || !booking) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <div className="text-center">
                    <i className="ri-error-warning-line text-danger" style={{ fontSize: '3rem' }}></i>
                    <h4 className="mt-3">Invoice Not Found</h4>
                    <p className="text-muted">{error || "The requested invoice could not be retrieved."}</p>
                </div>
            </div>
        );
    }

    const html = getInvoiceHTML(booking, settings);

    return (
        <React.Fragment>
            <style>
                {`
                    @media print {
                        .no-print {
                            display: none !important;
                        }
                        body {
                            padding: 0;
                            margin: 0;
                            background: white;
                        }
                        .invoice-view-container {
                            padding: 0 !important;
                            background: white !important;
                        }
                        .invoice-content-card {
                            box-shadow: none !important;
                            margin: 0 !important;
                            width: 100% !important;
                            max-width: none !important;
                        }
                    }
                    .invoice-view-container {
                        background: #f4f7f6;
                        min-height: 100vh;
                        padding: 40px 20px;
                    }
                    .invoice-actions {
                        max-width: 100%;
                        margin: 0 auto 20px auto;
                        display: flex;
                        justify-content: flex-end;
                        gap: 10px;
                    }
                    .invoice-content-card {
                        background: white;
                        max-width: 100%;
                        margin: 0 auto;
                        box-shadow: 0 10px 30px rgba(0,0,0,0.1);
                        border-radius: 8px;
                        overflow: hidden;
                    }
                `}
            </style>
            <div className="invoice-view-container">
                <div className="invoice-actions no-print">
                    <button
                        onClick={() => window.print()}
                        className="btn btn-primary d-flex align-items-center gap-2"
                        style={{ borderRadius: '6px', fontWeight: '600' }}
                    >
                        <i className="ri-printer-line"></i> Print Invoice
                    </button>
                    <button
                        onClick={() => window.close()}
                        className="btn btn-light"
                        style={{ borderRadius: '6px' }}
                    >
                        Close
                    </button>
                </div>
                <div className="invoice-content-card">
                    <div dangerouslySetInnerHTML={{ __html: html }} />
                </div>
            </div>
        </React.Fragment>
    );
};

export default InvoiceView;

